import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, useAuth, formatApiError } from "../context/AuthContext";
import { IndosbookMark } from "./IndosbookLogo";
import { Loader2 } from "lucide-react";

// Handles the return from Google (/auth/google?code=...&state=...).
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const expected = localStorage.getItem("google_oauth_state");
    localStorage.removeItem("google_oauth_state");
    if (!code || !state || state !== expected) {
      setError(params.get("error") === "access_denied" ? "Google sign-in was cancelled." : "Google sign-in could not be verified. Please try again.");
      return;
    }
    (async () => {
      try {
        const res = await api.post("/auth/google/callback", { code, redirect_uri: window.location.origin + "/auth/google" });
        setUser(res.data.user);
        navigate(res.data.needs_role ? "/onboarding" : "/feed", { replace: true });
      } catch (e) {
        setError(formatApiError(e?.response?.data?.detail, "Google sign-in failed. Please try again."));
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-white px-4 text-center" data-testid="google-callback">
      <IndosbookMark size={48} />
      {error ? (
        <>
          <p className="text-sm font-semibold text-red-600" data-testid="google-callback-error">{error}</p>
          <button onClick={() => navigate("/login", { replace: true })} data-testid="google-callback-back"
            className="rounded-full bg-[#FF4500] px-6 py-2.5 text-sm font-bold text-white hover:bg-[#e03d00]">Back to log in</button>
        </>
      ) : (
        <div className="flex items-center gap-2 text-gray-500">
          <Loader2 className="h-5 w-5 animate-spin text-[#FF4500]" /> Signing you in…
        </div>
      )}
    </div>
  );
}
